module.exports = __webpack_public_path__ + "img/interaction-bar-infiniti.02e11475.png";